import React, { useCallback, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Select } from 'antd';

import { getAllLanguage } from '../../utils/services/languageApi';
import { InputContainer, InputLabel } from './styles';
import { CREATE_BLOCK_MODAL } from './translationValues';
import { isLanguageTranslationDisabled } from '../../utils/detectLanguageHelper';
import { useSessionContext } from '../../context/sessionContext';

export const useSelectedTemplateLanguage = () => {
  const [templateLanguage, setTemplateLanguage] = useState();
  const [languages, setLanguages] = useState([]);

  const organisationSelector = useCallback(store => store.organisationDetails, []);
  const [organisationDetails] = useSessionContext(organisationSelector);

  const getLanguages = async () => {
    const response = await getAllLanguage();
    if (response && response.data && Array.isArray(response.data)) {
      setLanguages(response.data);
      setTemplateLanguage(response.data[0].code);
    }
  };

  useEffect(() => {
    isLanguageTranslationDisabled(organisationDetails) && getLanguages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { templateLanguage, setTemplateLanguage, languages, setLanguages };
};

const NAMESPACES = ['CREATE_BLOCK_MODAL'];
export const AvailableLanguagesDropdown = ({
  templateLanguage,
  languages,
  setTemplateLanguage,
}) => {
  const organisationSelector = useCallback(store => store.organisationDetails, []);
  const [organisationDetails] = useSessionContext(organisationSelector);
  const { t } = useTranslation(NAMESPACES);

  return isLanguageTranslationDisabled(organisationDetails) && languages?.length > 0 ? (
    <InputContainer>
      <InputLabel>
        {t(CREATE_BLOCK_MODAL.LANGUAGE_LABEL.key, CREATE_BLOCK_MODAL.LANGUAGE_LABEL.value)}
      </InputLabel>
      <Select 
        value={templateLanguage} 
        onChange={lang => setTemplateLanguage(lang)} 
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }>
        {languages?.map(item => (
          <Select.Option value={item.code}>{item.name}</Select.Option>
        ))}
      </Select>
    </InputContainer>
  ) : null;
};
